import { useLocalization } from '../../utils/hooks/useLocalization'
import ReactCountryFlag from "react-country-flag";
import styles from './LanguageSelector.module.css';

const LanguageSelector = () => {
  const { currentLanguage, changeLanguage, getSupportedLanguages } = useLocalization();
  
  const mapper = {
    it: "it",
    en: "gb"
  }

  return (
    <div className={styles.container}>
      {getSupportedLanguages().map(lang => (
        <ReactCountryFlag
          key={lang}
          countryCode={(mapper[lang] || lang).toUpperCase()} svg style={{ width: "2.5em", height: "2.5em" }}
          onClick={(e) => changeLanguage(lang)}
          className={lang == currentLanguage ? `${styles.active} ${styles.flag}` : styles.flag}
        />
      ))}
    </div>
  );
};

export default LanguageSelector


